import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '@/services/apiService';
import { mapState, mapGetters } from 'vuex';
import routerPaths from './router/paths';
import { themeDefaults, themeColors } from './utils/themes';
import customColorMixin from './mixins/customColor';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
export default {
  name: 'App',
  mixins: [customColorMixin],
  data: function data() {
    return {
      eulaKey: 'initial',
      brandingLoaded: false,
      breadcrumbs: null,
      pageTitle: {},
      themesData: {},
      footer: {}
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['load', 'loading', 'language', 'UiTheme', 'color'])), mapGetters({
    sessionUser: 'authentication/user',
    tenantId: 'authentication/tenantId'
  })), {}, {
    userId: function userId() {
      return get(this, '$store.state.authentication.user.id') || null;
    },
    showEulaDialog: function showEulaDialog() {
      return get(this, '$store.state.authentication.isImpersonating', false) === false && get(this, '$store.state.authentication.status', '') === 'success' && get(this, '$store.state.authentication.user.properties.eula.accepted', false) === false && get(this.$route, 'meta.noAuth', false) === false;
    },
    fontClass: function fontClass() {
      return this.$store.state.app.useAltFonts ? 'font-alt' : '';
    },
    showAppLayout: function showAppLayout() {
      if (get(this.$route, 'meta.hideLayout')) {
        return false;
      }

      switch (this.$route.path) {
        case '/login':
        case '/error':
        case '/reset-password':
        case '/change-password':
        case '/oauth':
        case '/':
          return false;

        default:
          return true;
      }
    },
    fireflyHost: function fireflyHost() {
      return process.env.VUE_APP_FIREFLY_HOST;
    },
    host: function host() {
      return "".concat(window.location.protocol, "//").concat(window.location.hostname || window.location.host);
    }
  }),
  watch: {
    $route: function $route() {
      var _this = this;

      this.$nextTick(function () {
        _this.updateBreadcrumbs();
      });
    },
    language: function language() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.updateBreadcrumbs();
      });
    },
    userId: function userId() {
      this.loadBranding();
      var tenantID = get(this, '$store.state.authentication.tenantId');
      var token = get(this, '$store.state.authentication.token');

      if (tenantID && token) {
        this.getTenantData(tenantID);
      } else {
        console.info('No token found, skipping tenant data loading');
      }
    }
  },
  mounted: function mounted() {
    this.loadBranding();
  },
  updated: function updated() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.updateBreadcrumbs(); // force a store update in case computed showEulaDialog was not updated after login


      if (_this3.showEulaDialog === false && get(_this3, '$store.state.authentication.isImpersonating', false) === false && get(_this3, '$store.state.authentication.status', '') === 'success' && get(_this3, '$store.state.authentication.user.properties.eula.accepted', false) === false && get(_this3.$route, 'meta.noAuth', false) === false) {
        _this3.$store.state.authentication = cloneDeep(_this3.$store.state.authentication);
      }
    });
  },
  methods: {
    get: get,
    updateBreadcrumbs: function updateBreadcrumbs() {
      var newBreadCrumbsPath = null;
      var routerView = get(this.$refs, 'view.$refs.routerview');

      if (routerView && routerView.breadCrumbsPath) {
        newBreadCrumbsPath = routerView.breadCrumbsPath();
      }

      if (!isEqual(this.breadcrumbs, newBreadCrumbsPath)) {
        this.breadcrumbs = newBreadCrumbsPath;
      }
    },
    getLocalUserColor: function getLocalUserColor(storageKey) {
      var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'primary';
      var localColor = localStorage.getItem(storageKey);

      if (themeColors.indexOf(localColor) >= 0) {
        return localColor;
      }

      return fallback;
    },
    getSideBarIconLink: function getSideBarIconLink(sidebarIconLink) {
      var validLink = routerPaths.filter(function (path) {
        return (path.meta || {}).isDrawerIconLink && path.path === sidebarIconLink;
      });
      return (validLink[0] || {}).path || '/home';
    },
    setFavicon: function setFavicon(theme) {
      var link = document.createElement('link');
      link.type = 'image/png';
      link.rel = 'icon';

      if (!theme.favicon || theme.favicon === themeDefaults.favicon) {
        link.href = 'favicon/niotix-x-144x144.png';
      } else {
        link.href = process.env.VUE_APP_API_HOST + theme.favicon;
      }

      document.head.appendChild(link);
    },
    loadBranding: function () {
      var _loadBranding = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tenantId, userMode, theme, useAltFonts;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tenantId = get(this.$store, 'state.authentication.tenantIdThemeSetting') || get(this.$store, 'state.authentication.primaryTenantIds[0]'); // do not use `this.getThemeMode()` here, because we DON'T want a default-value
                // should use the tenant-branding-theme, IF user did not set up something

                userMode = String(localStorage.getItem('thingshiveTheme')).toLocaleLowerCase();

                if (userMode !== 'dark' && userMode !== 'light') {
                  userMode = this.$store.state.app.mode || null;
                }

                _context.next = 5;
                return this.$store.dispatch('app/loadBranding', {
                  hostUri: this.host,
                  tenantId: tenantId,
                  userThemeMode: userMode,
                  context: this
                });

              case 5:
                theme = _context.sent;
                this.pageTitle = this.$store.state.app.pageTitle;
                this.footer = this.$store.state.app.footer;
                this.$store.state.app.sidebarIconLink = this.getSideBarIconLink(theme.sidebarIconLink);
                this.$store.state.app.grafanaUrl = theme.grafanaUrl;
                this.$store.state.app.fireflyUrl = "https://".concat(this.fireflyHost); // use vollkorn as default font as long as the digimondo logo was not changed

                useAltFonts = theme.useAltFonts === undefined ? !this.isDefaultSvgLogo() : theme.useAltFonts;
                this.$store.commit('app/useAltFonts', {
                  payload: useAltFonts
                });
                this.$store.state.app.useCustomBackground = theme.useCustomBackground === undefined ? themeDefaults.useCustomBackground : theme.useCustomBackground;
                this.setFavicon(theme); // set vue ui mode

                this.$vuetify.theme.dark = this.themeGetMode() === 'dark';
                this.themesData = this.$store.state.app.themes;
                this.brandingLoaded = true;

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadBranding() {
        return _loadBranding.apply(this, arguments);
      }

      return loadBranding;
    }(),
    getTenantData: function getTenantData(tenantId) {
      var _this4 = this;

      ApiService.tenantGetById(tenantId, ['no-descendents']).then(function (tenants) {
        var feedbackEmail = get(tenants, 'data.feedback.bug') || 'support@digimondo.de';

        _this4.$store.commit('app/setFeedbackEmail', feedbackEmail);
      }).catch(function (error) {
        // only print error-messages for tenant-data, if this is not a redirect
        // in case of Node-RED or Grafana opening, it will shortly display the login-page before redirecting;
        // anything other than the Auth shall not disturb the user, so an error fetching the tenant-data is not pertinent
        if (!get(_this4.$router, 'query.redirect')) {
          if (error.response && _this4.$i18n_t("Error.".concat(error.response.data.message))) {
            _this4.$snack(_this4.$i18n_t("Error.".concat(error.response.data.message)), 'error');
          } else {
            _this4.$snack(_this4.$i18n_t('Common.tenantReadFail'), 'error');
          }
        }

        _this4.$store.commit('app/setFeedbackEmail', 'support@digimondo.de');
      }).finally(function () {
        _this4.$store.state.app.loading = false;
      });
    }
  }
};